import { render } from "./NotificationSecondFeature.vue?vue&type=template&id=48e6e4f3&ts=true"
import script from "./NotificationSecondFeature.vue?vue&type=script&lang=ts"
export * from "./NotificationSecondFeature.vue?vue&type=script&lang=ts"

import "./NotificationSecondFeature.vue?vue&type=style&index=0&id=48e6e4f3&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__